module.exports = __webpack_public_path__ + "static/img/culture_three.6c0d435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporateCulture/culture_three.png
// module id = bYAO
// module chunks = 1